import {Article, ArticleState} from '../interfaces';

export const getters = {
  articles: (state: ArticleState): Article[] => state.articles,
  hasArticles: (state: ArticleState): boolean => state.articles.length > 0,
};
